import {Container, Graphics, Text} from 'pixi.js';

/**
 * The title screen: a single START row — the survival ladder has no modes,
 * every game opens on the easy grid via Game.selectDifficulty() and climbs
 * by round. Target sized for a kiosk touchscreen.
 */
const MONO = 'Courier New, monospace';

export function makeTitle() {
  const c = new Container();
  c.addChild(new Graphics().rect(0, 0, 800, 600).fill(0x000000));

  const title = new Text({
    text: 'DUCK HUNT',
    style: {fontFamily: MONO, fontSize: 80, fontWeight: '700', fill: 0xfc6955, stroke: {color: 0x7e6500, width: 7}}
  });
  title.anchor.set(0.5);
  title.position.set(400, 105);
  c.addChild(title);

  const sub = new Text({
    text: 'by firehose.games',
    style: {fontFamily: MONO, fontSize: 17, fill: 0xffffff}
  });
  sub.anchor.set(0.5);
  sub.position.set(400, 168);
  c.addChild(sub);

  const credit = new Text({
    text: 'an AT Protocol remix of DuckHunt-JS · duckhuntjs.com',
    style: {fontFamily: MONO, fontSize: 13, fill: 0xffffff}
  });
  credit.anchor.set(0.5);
  credit.position.set(400, 196);
  c.addChild(credit);

  const rows = [
    {name: 'hunt', label: 'START'}
  ];
  const hitRows = [];
  rows.forEach((row, i) => {
    const y = 252 + i * 96;
    c.addChild(new Graphics().roundRect(110, y, 580, 72, 6)
      .stroke({width: 3, color: 0xffffff, alpha: 0.65}));
    const label = new Text({
      text: row.label,
      style: {fontFamily: MONO, fontSize: 23, fontWeight: '700', fill: 0xffffff}
    });
    label.anchor.set(0.5);
    label.position.set(400, y + 36);
    c.addChild(label);
    hitRows.push({name: row.name, x0: 110, x1: 690, y0: y, y1: y + 72});
  });

  return {container: c, hitRows};
}
